<section>
  <div class="plan">
    <div class="d-flex flex-column align-items-start justify-content-between plan-free">
      <div class="plan-header w-100">
        <div class="w-100 price-block">
          <h2><b [innerText]="planTiers[selectedPlan.tier]"></b></h2>
          <h2 class="price"><b>{{ 0 | currency: 'USD' : 'symbol' : '1.0-0' }}</b></h2>
        </div>
      </div>

      <div class="mt-2 w-100 h-100 d-flex flex-column justify-content-between">
        <div class="d-flex flex-column plan-options">
          <p class="option" *ngFor="let benefit of benefits[selectedPlan.tier]">
            <tr-icon [icon]="icon.check" [color]="iconColor.green"></tr-icon>
            {{ benefit }}
          </p>
        </div>

        <div>
          <div class="plan-footer w-100 d-flex flex-row justify-content-center align-self-end">
            <button class="btn btn-info" *ngIf="showCurrentPlanBtn" disabled>Current Plan</button>
            <button
              class="btn btn-success btn-wide"
              *ngIf="!showCurrentPlanBtn"
              (click)="updateSubscription.emit(selectedPlan.plan_code)"
              [disabled]="disableDowngradeBtn"
            >Switch plans</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
